var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { memo, useMemo, } from 'react';
import classNames from 'classnames/bind';
import { Text } from '../../text';
import { BUTTON_VARIANTS } from '../constants';
import styles from '../button-link.module.scss';
import { ButtonLoader } from './button-loader';
var cn = classNames.bind(styles);
var BLOCK_NAME = 'Button-link';
export var ButtonLinkView = memo(function (_a) {
    var _b, _c, _d, _e;
    var fullWidth = _a.fullWidth, isBreadcrumbs = _a.isBreadcrumbs, isDarkTheme = _a.isDarkTheme, isLoading = _a.isLoading, isPopUp = _a.isPopUp, isTextCenter = _a.isTextCenter, isUpperCase = _a.isUpperCase, LeftIcon = _a.leftIcon, onClick = _a.onClick, RightIcon = _a.rightIcon, routeName = _a.routeName, size = _a.size, Tag = _a.tagName, tagOptionalProps = _a.tagOptionalProps, _f = _a.text, text = _f === void 0 ? '' : _f, textSize = _a.textSize, variant = _a.variant, buttonRef = _a.buttonRef, notFullWidthOnMobile = _a.notFullWidthOnMobile, onMouseOver = _a.onMouseOver, onMouseEnter = _a.onMouseEnter, onFocus = _a.onFocus, textColor = _a.textColor, isTextLeft = _a.isTextLeft, textWhiteSpace = _a.textWhiteSpace, textRef = _a.textRef, onBlur = _a.onBlur;
    var isLink = useMemo(function () {
        return variant === BUTTON_VARIANTS.link ||
            variant === BUTTON_VARIANTS['link-without-underline'];
    }, [variant]);
    var isOnlyIcon = useMemo(function () { return variant === BUTTON_VARIANTS.onlyIcon; }, [variant]);
    var isOnlyIconInline = useMemo(function () { return variant === BUTTON_VARIANTS.onlyIconInline; }, [variant]);
    var isIconWithText = useMemo(function () { return text && (LeftIcon || RightIcon); }, [LeftIcon, RightIcon, text]);
    var isTextComponent = useMemo(function () {
        return text &&
            !isOnlyIcon &&
            !isOnlyIconInline &&
            (variant === 'link' ||
                variant === 'link-without-underline' ||
                variant === 'list-item' ||
                variant === 'list-item-active');
    }, [text, isOnlyIcon, variant, isOnlyIconInline]);
    var isOrdinaryText = useMemo(function () { return text && !isOnlyIcon && !isOnlyIconInline; }, [text, isOnlyIcon, isOnlyIconInline]);
    var buttonTextColor = useMemo(
    // Для ссылки нужно что текст всегда принимал свойства цвета от родительского <a>
    // Для остальных случаев возможна установка заданного цвета
    function () { return (isLink ? 'inherit' : textColor || 'inherit'); }, [textColor, isLink]);
    var linkTextColor = useMemo(function () { return textColor || 'blue'; }, [textColor]);
    return (
    // eslint-disable-next-line
    // @ts-ignore due to a different set of props the type can't be defined properly
    React.createElement(Tag, __assign({ ref: buttonRef, className: cn("".concat(BLOCK_NAME), (_b = {},
            _b["".concat(BLOCK_NAME, "--full-width")] = fullWidth,
            _b["".concat(BLOCK_NAME, "--text-center")] = isTextCenter,
            _b["".concat(BLOCK_NAME, "--text-left")] = isTextLeft,
            _b["".concat(BLOCK_NAME, "--link-breadcrumbs")] = isLink && isBreadcrumbs,
            _b["".concat(BLOCK_NAME, "--link-").concat(linkTextColor)] = isLink && Boolean(linkTextColor),
            _b["".concat(BLOCK_NAME, "--link-pop-up")] = isLink && isPopUp,
            _b["".concat(BLOCK_NAME, "--link-pop-up-dark")] = isLink && isPopUp && isDarkTheme,
            _b["".concat(BLOCK_NAME, "--button")] = !isLink,
            _b["".concat(BLOCK_NAME, "--").concat(variant)] = Boolean(variant),
            _b["".concat(BLOCK_NAME, "--only-icon-").concat(size)] = isOnlyIcon,
            _b["".concat(BLOCK_NAME, "--").concat(variant, "-dark")] = Boolean(variant) && isDarkTheme,
            _b["".concat(BLOCK_NAME, "--button-").concat(size)] = !isLink && Boolean(size),
            _b["".concat(BLOCK_NAME, "--no-text-").concat(size)] = !Boolean(text) && !isOnlyIconInline,
            _b["".concat(BLOCK_NAME, "--icon-text-").concat(size)] = isIconWithText,
            _b["".concat(BLOCK_NAME, "--not-full-mobile-width")] = notFullWidthOnMobile,
            _b)), onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseEnter: onMouseEnter, onMouseOver: onMouseOver }, tagOptionalProps),
        LeftIcon && (React.createElement("span", { className: cn("".concat(BLOCK_NAME, "__icon"), (_c = {},
                _c["".concat(BLOCK_NAME, "__icon--left-").concat(size)] = Boolean(size) && !isOnlyIconInline,
                _c["".concat(BLOCK_NAME, "__icon--no-text")] = !Boolean(text) || isOnlyIcon || isOnlyIconInline,
                _c["".concat(BLOCK_NAME, "__icon--have-right-icon")] = !Boolean(text) && Boolean(RightIcon),
                _c)) },
            React.createElement(LeftIcon, null))),
        isTextComponent ? (React.createElement(Text, { color: buttonTextColor, isUpperCase: isUpperCase, size: textSize, text: text, textRef: textRef, whiteSpace: textWhiteSpace })) : (isOrdinaryText && (React.createElement("span", { className: cn("".concat(BLOCK_NAME, "__text"), (_d = {},
                _d["".concat(BLOCK_NAME, "__text--uppercase")] = isUpperCase,
                _d["".concat(BLOCK_NAME, "__text--white-space-").concat(textWhiteSpace)] = Boolean(textWhiteSpace),
                _d)) }, text))),
        RightIcon && (React.createElement("span", { className: cn("".concat(BLOCK_NAME, "__icon"), (_e = {},
                _e["".concat(BLOCK_NAME, "__icon--right-").concat(size)] = Boolean(size) && !isOnlyIconInline,
                _e["".concat(BLOCK_NAME, "__icon--no-text")] = !Boolean(text),
                _e["".concat(BLOCK_NAME, "__icon--have-left-icon")] = !Boolean(text) && Boolean(LeftIcon),
                _e)) },
            React.createElement(RightIcon, null))),
        !Boolean(routeName) && !isLink && (React.createElement(ButtonLoader, { isDarkTheme: isDarkTheme, isLoading: isLoading, variant: variant }))));
});
